































import { Component, Inject } from 'vue-property-decorator';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { LessonCategoryEntity } from '@/entities/lesson-category.entity';

@Component<SideBar>({
  components: { CSideBar },
})
export default class SideBar extends CreateListDataMixin<LessonCategoryEntity>(
  'lesson-category',
) {
  // items: LessonCategoryEntity[]

  @Inject('sideDrawer')
  sideDrawer!: boolean;
}
